<template>
  <div id="main">
    <el-container>
      <el-main>
        <div style="height: 100%;width: 100%">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="创建角色" name="0">
              <el-form label-position="right" label-width="80px" :model="formLabelAlign"
                       style="width: 50%;margin: auto;">
                <el-form-item label="角色名字">
                  <el-input v-model="roleName" placeholder="请输入角色名字"></el-input>
                </el-form-item>
                <el-form-item label="角色权限">
                  <el-select v-model="selectDroit" placeholder="请选择权限" multiple collapse-tags>
                    <el-option v-for="(droit,index) in droitList"
                               :key="index"
                               :label="droit.action_iden"
                               :value="droit.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary" @click="createRole(roleName,selectDroit)">创建角色</el-button>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="分配权限" name="1">
              <el-form label-position="right" label-width="80px" :model="formLabelAlign"
                       style="width: 50%;margin: auto;">
                <el-form-item label="角色名">
                  <el-input v-model="activeName"></el-input>
                </el-form-item>
                <el-form-item label="部门名称">
                  <el-input v-model="activeName"></el-input>
                </el-form-item>
                <el-form-item label="活动区域">
                  <el-select v-model="formLabelAlign.region" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary">确认信息</el-button>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import authority from "../../api/authority";
    export default {
        data() {
            return {
                droitList:[],
                activeName: '0',
                roleName:'',
                selectDroit:[],
                //以下为测试变量
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: '',
                },
            };
        },
        methods: {
            //获取权限
            getDroitList(){
                this.droitList=[]
                authority.getDroitList().then((res)=>{
                    res.map((item)=>{
                        this.droitList.push(item)
                    })
                }).catch((err)=>{
                    this.$message.error(`权限查询失败 (${err[0]})：${err[1]}`)
                })
            },
            //创建角色
            createRole(roleName,droitId){
                authority.createRole(roleName,droitId).then((res)=>{
                    this.$message({
                        type: 'success',
                        message:'角色创建成功',
                    });
                    this.roleName=''
                    this.selectDroit=[]
                }).catch((err) =>{
                    this.$message.error(`角色创建失败 (${err[0]})：${err[1]}`)
                })
            }
        },
        mounted(){
            this.getDroitList()
        }
    };
</script>

<style scoped>

  #main {
    width: 100%;
    height: 100%;
    background-color: #F9F9F9;
  }

  .el-header, .el-footer {
    color: #333;
    text-align: center;
    line-height: 60px;
    height: 10%;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    color: #333;
    line-height: 160px;
    height: 75%;
    width: 100%;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container {
    height: 100%;
    width: 100%;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>



// WEBPACK FOOTER //
// src/components/authority/roleCreate.vue